<template>
  <gg-card>
    <gg-card-header>
      Autoupdate Status
    </gg-card-header>
    <gg-card-text>
      <v-data-table
        :items="items"
        :loading="loadingInfo || loadingInst"
        :headers="headers"
      >
        <template #item.softurl="{ item }">
          <a :href="item.softurl" target="_blank">{{ item.softurl }}</a>
        </template>
        <template #item.status="{ item }">
          {{ item.needsUpdate ? 'Out of Date' : 'Up to Date' }}
        </template>
        <template #item.actions="{ item }">
          <gg-btn v-if="item.needsUpdate" @click="openModal(item)">Update</gg-btn>
        </template>
      </v-data-table>
      <update-modal
        :opened="modal"
        :installation="selectedInst"
        @close="closeModal"
        @updated="fetchInstallations"
      />
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import UpdateModal from '../Modals/UpdateModal'

export default {
  name: 'AutoupdateList',
  components: { UpdateModal },
  data () {
    return {
      loadingInfo: false,
      loadingInst: false,
      modal: false,
      headers: [
        { text: 'URL', value: 'softurl' },
        { text: 'Installation', value: 'script_name' },
        { text: 'Status', value: 'status' },
        { text: 'Version', value: 'ver' },
        { text: '', value: 'actions' },
      ],
      selectedInst: null,
    }
  },
  computed: {
    ...mapGetters({
      installations: 'hosting_wp/installations',
    }),
    items () {
      return this.installations.filter(inst => inst.script_name == 'WordPress')
    }
  },
  methods: {
    ...mapActions({
      getWpInfo: 'hosting_wp/getWpInfo',
      getInstallationsList: 'hosting_wp/getInstallationsList',
      reportError: 'reportError',
    }),
    async fetchWpInfo () {
      this.loadingInfo = true
      try {
        await this.getWpInfo(this.$route.query.user)
      } catch (e) {
        console.warn(e)
      } finally {
        this.loadingInfo = false
      }
    },
    async fetchInstallations (withInfo = false) {
      if (withInfo) {
        await this.fetchWpInfo()
      }
      this.loadingInst = true
      try {
        await this.getInstallationsList(this.$route.query.user)
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loadingInst = false
      }
    },
    openModal (inst) {
      this.selectedInst = inst
      this.modal = true
    },
    closeModal () {
      this.modal = false
      this.selectedInst = null
    },
  },
  mounted () {
    this.fetchInstallations(true)
  }
}
</script>
